<template>
    <BaseEditPage
        :context="context"
        :alvqa="alvqa"
        cancelIconRoute="/publishing/projects"
    >
<!-- HEADLINE  -->
        <template v-slot:headline="{ data }">
            <div class="d-flex align-center">
                <div :alvqa="alvqa + '-title'">
                    {{ data.title ? data.title : $t('lang_GENERAL_CAPTION_EDIT_PAGE_UNTITLED') }}
                </div>
                <div class="ml-2" style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;">
                    <ContextHelpIcon
                        v-if="hasContextHelp && (data.title || $route.params.alvId === 'new')"
                        context="PublishingProjectsEdit"
                        :alvqa="alvqa + '-context-help-icon'"
                    />
                </div>
            </div>
        </template>
<!-- EDIT FORM  -->
        <template v-slot:editForm>
            <!-- 1st column -->
            <v-col cols="2">
                <v-row>
                    <v-col>
                        <!-- <v-img 
                            v-if="data.image !== null || data.image !== ''"
                            :src="data.image"
                        ></v-img> -->
                        <v-img
                            aspect-ratio="1"
                            class="defaultImageEditPage"
                            :alvqa="alvqa + '-image'"
                        >
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                                <!-- <BaseIcon 
                                    @click="uploadReleaseImage()"
                                    icon="cloud_upload"
                                    tooltipText="lang_GENERAL_CAPTION_UPLOAD_IMAGE"
                                />   -->
                            </v-row>
                        </v-img>
                    </v-col>
                </v-row>
            </v-col> 
            <!-- 2nd column -->
            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Title"
                        :label="$t('lang_PUBLISHING_PROJECTS_CAPTION_TITLE')"
                        :alvqa="alvqa + '-textfield-title'"
                        rules="required"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="ProductionTypeId"
                        :items="productionTypeOptions"
                        :label="$t('lang_PUBLISHING_RELEASES_CAPTION_PRODUCTION_TYPE')"
                        :selection="true"
                        :alvqa="alvqa + '-dropdown-production-type'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageAutocomplete 
                        :context="context"
                        field="Producer"
                        :label="$t('lang_PUBLISHING_RELEASES_CAPTION_PRODUCER')"
                        :alvqa="alvqa + '-autocomplete-producer-textfield'"
                    >
                        <template v-slot:selection="{ item }">
                            <div class="ellipsis" :alvqa="alvqa + '-autocomplete-producer-selection'">
                                {{ item.gemaName }}
                                <span v-if="$alvPlugin.printName(item)">
                                    ({{ item.firstName }} {{ item.lastName }})
                                </span>
                            </div>
                        </template>
                        <template v-slot:items="{ items }">
                            <v-list-item-content :alvqa="alvqa + '-autocomplete-producer-dropdown-' + items.alvId">
                                <v-list-item-title :alvqa="alvqa + '-autocomplete-producer-dropdown-' + items.alvId + '-title'">
                                    {{ items.gemaName }}
                                    {{ $alvPlugin.printName(items) ? '(' + items.firstName + ' ' + items.lastName +')' : ''}}
                                    <!--  
                                        typeOfAz:
                                            allowed values: P, D or G
                                            P => Person => P in circle
                                            D => Distributor => D in circle (in german V for 'Vertrieb')
                                            G => Group => G in circle                                                
                                        -->
                                        <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                        <!-- TODO: check i18n {{ i18n.locale === 'de' && items.item.typeOfAz === 'D' ? 'V' : items.item.typeOfAz }} -->
                                </v-list-item-title>
                                <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-producer-dropdown-' + items.alvId + '-subtitle'">
                                    {{ $t('lang_IPI') }}: {{ items.ipi !== null && items.ipi !== "" && items.ipi !== undefined ? items.ipi : $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') }} | {{ items.alvId }}                                      
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>                        
                    </BaseEditPageAutocomplete>
                </v-row>
                <v-row>
                    <BaseEditPageTextarea 
                        :context="context"
                        field="Note"
                        :label="$t('lang_PUBLISHING_RELEASES_CAPTION_NOTE')"
                        :alvqa="alvqa + '-textarea-note'"
                    />
                </v-row> 
            </v-col>
            <!-- 3rd column -->
            <v-col cols="2">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AlvId"
                        :label="$t('lang_CAPTION_ALVID')"
                        :alvqa="alvqa + '-textfield-alvid'"
                        :clearable="false"
                        :readonly="true"
                    />
                </v-row>
            </v-col>
            <!-- 4th column -->
            <!-- <v-col cols="2"></v-col> -->
            <!-- 5th column -->
            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="TvStation"
                        :label="$t('lang_PUBLISHING_RELEASES_CAPTION_TV_STATION_NAME')"
                        :alvqa="alvqa + '-textfield-tv-station'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Tag"
                        :label="$t('lang_PUBLISHING_RELEASES_CAPTION_TAGS')"
                        :alvqa="alvqa + '-textfield-tag'"
                    />
                </v-row> 
            </v-col>
            <v-col>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Favourite"
                        :items="getDropdownYesNo" 
                        :label="$t('lang_GENERAL_FAVOURITE')" 
                        :alvqa="alvqa + 'dropdown-favourite'"
                        :clearable="false"
                    />
                </v-row>
            </v-col>
        </template>
        <template v-slot:panels>
            <ContextHelpDialog />
            <DeletionDialog :useContextSetinVuex="true" />
            <SheetsPanel />
            <SearchDialog
                context="Projects"
                subcontext="ProjectsSheets"
                searchcontext="ProjectsSheet"
                addcontext="SheetToProjects"
                addButtonLabel="lang_PUBLISHING_RELEASES_BUTTON_CAPTION_ADD_SHEETS"
                dialogTitle="lang_PUBLISHING_RELEASES_BUTTON_CAPTION_ADD_SHEETS"
                :alvqaContext="alvqa"
            >
                <template v-slot:itemTitle="{ item }">
                    {{ item.title }} {{ item.sheetNumber ? '(' + item.sheetNumber + ')' : '' }}
                </template>

            </SearchDialog>
        </template>         
    </BaseEditPage>
</template>

<script>
import BaseEditPage from '@/components/_base/BaseEditPage'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

import SearchDialog from '@/components/_dialogs/SearchDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import ContextHelpIcon from '@/components/_buttons/ContextHelpIcon'
import ContextHelpDialog from '@/components/_dialogs/ContextHelpDialog'

import SheetsPanel from './_panels/SheetsPanel'

import { DropdownGenericYesNo } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "PublishingProjectsEdit",
    components: {
        BaseEditPage,
        BaseIcon,
        BaseEditPageTextField,
        BaseEditPageTextarea,
        BaseEditPageAutocomplete,
        BaseEditPageDropdown,

        SheetsPanel,
        DeletionDialog,

        SearchDialog,
        ContextHelpIcon,
        ContextHelpDialog
    },
    data() {
        return {
            context: "PublishingProjects",
            alvqa: "publishing-projects-edit-form",
            hasContextHelp: false
        }
    },
    computed: {
        productionTypeOptions() { 
            return [
                {header: this.$t("lang_PUBLISHING_RELEASES_CAPTION_CINEMA")},
                {
                    text: "lang_PUBLISHING_RELEASES_CAPTION_FILM", 
                    value: 1, 
                    group: "lang_PUBLISHING_RELEASES_CAPTION_CINEMA",
                    alvqa: this.alvqa + '-dropdown-production-type-film'

                },
                {
                    text: "lang_PUBLISHING_RELEASES_CAPTION_SHORT_FILM", 
                    value: 2, 
                    group: "lang_PUBLISHING_RELEASES_CAPTION_CINEMA",
                    alvqa: this.alvqa + '-dropdown-production-type-short-film'
                },
                {header: this.$t("lang_PUBLISHING_RELEASES_CAPTION_TELEVISION")},
                {
                    text: "lang_PUBLISHING_RELEASES_CAPTION_INHOUSE_COMMISSIONED_PRODUCTION", 
                    value: 3, 
                    group: "lang_PUBLISHING_RELEASES_CAPTION_TELEVISION",
                    alvqa: this.alvqa + '-dropdown-production-type-inhouse-commissioned-production'
                },
                {
                    text: "lang_PUBLISHING_RELEASES_CAPTION_SHOW", 
                    value: 4, 
                    group: "lang_PUBLISHING_RELEASES_CAPTION_TELEVISION",
                    alvqa: this.alvqa + '-dropdown-production-type-show'
                },
                {
                    text: "lang_PUBLISHING_RELEASES_CAPTION_OTHER_TELEVISION_PRODUCTION", 
                    value: 5, 
                    group: "lang_PUBLISHING_RELEASES_CAPTION_TELEVISION",
                    alvqa: this.alvqa + '-dropdown-production-type-television'
                }
            ]
        },

        getDropdownYesNo() { return DropdownGenericYesNo },
    },
    methods: {
        uploadReleaseImage() {
            this.$store.commit('setSnackbar', {
                type: 'warning',
                msg: "This page is under construction. No image upload function yet!"
            })
        }
    },
    async created() {
        this.hasContextHelp = await this.$alvPlugin.checkContextHelpAvailability('PublishingProjectsEdit')
    }
}
</script>

<style scoped>
    .v-image.defaultImageEditPage {
        background-color: #eeeeee !important;
    }
    
    .v-image.defaultImageEditPage .v-responsive__content {
        background-color: #eeeeee !important;
    }
</style>